import { gql } from './apollo';

export const GET_GC_INVENTORY_EMAIL_LIST_FOR_PROPERTY = gql`
    query ($property_id: MultiTypeInput!) {
        table(
            name: "gc_inventory_email_list"
            filter: [{ left: "property__c_id", right: $property_id, expression: "=" }]
            limit: 1
        )
    }
`;
